// @flow
/* eslint-disable import/prefer-default-export */
export const formatArrayToCommaSeparatedString = (array: Array<string>): string => {
  if (array.length === 0) {
    return '';
  }
  if (array.length === 1) {
    return array[0];
  }

  if (array.length === 2) {
    return `${array[0]} and ${array[1]}`;
  }

  return `${array.slice(0, array.length - 1).join(', ')}, and ${array[array.length - 1]}`;
};
